

















































































































import { Component, Vue } from "vue-property-decorator";

import { io } from "socket.io-client";
import store from "@/store";
import router from "@/router";
@Component({
  components: {},
})
export default class Home extends Vue {
  public clickedStart = false;
  public hasStarted = false;
  public startGame() {
    this.clickedStart = true;

    setTimeout(() => {
      if (!this.hasStarted) {
        alert("If it's taking more than 5 seconds, my credits have probably ran out 😱 apologies.");
      }
    }, 5000);
    const socket = io(process.env.VUE_APP_SERVER);
    store.commit("setSocket", socket);
    store.state.socket.on("room", (roomId: string) => {
      this.hasStarted = true;

      router.push({ path: `game/${roomId}` });
   });
  }
}
